const lazyVideoReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

// A video with a pause button (motion-toggle.js) stays on its poster while paused. Before the button sets a
// state, it is paused when the visitor prefers reduced motion.
function isHeldStill(video) {
    if (video.nextElementSibling?.localName !== 'motion-toggle') return false;

    const state = video.dataset.motionState;
    return state ? state === 'paused' : lazyVideoReducedMotion.matches;
}

// Called after load() for a lazy video: loading resets the browser's autoplay, pausing cancels it.
function holdStill(video) {
    if (!video.dataset.src) video.pause();
    video.classList.add('is-blocked');
}

// Autoplay was refused. A pause button (motion-toggle.js) listens so it can offer Play again.
function blockVideo(video) {
    video.classList.add('is-blocked');
    video.dispatchEvent(new Event('lazy-video:blocked'));
}

// Autoplay videos rendered with a poster image stay hidden until they play.
// When autoplay is blocked (iOS Low Power Mode, data saver), they stay hidden and the poster shows.
function revealWhenPlaying(video) {
    if (video.dataset.revealBound) return;
    video.dataset.revealBound = 'true';

    const show = () => video.classList.add('is-playing');
    if (!video.paused && video.readyState >= 3) show();
    video.addEventListener('playing', show, { once: true });

    if (isHeldStill(video)) return holdStill(video);

    // Lazy videos start from the observer below. Hidden breakpoint copies never start.
    if (video.dataset.src || !video.getClientRects().length) return;

    const attempt = video.play();
    if (attempt) attempt.catch(() => blockVideo(video));
}

document.querySelectorAll('video.lazy-video--reveal').forEach(revealWhenPlaying);

// Starts once the page is parsed rather than at the load event, so the on-screen hero video begins
// promptly; off-screen and hidden videos still wait (a hidden breakpoint copy never intersects).
function observeLazyVideos() {
    const videos = document.querySelectorAll('video[data-src]');
    if (!videos.length) return;

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            const video = entry.target;
            const src = video.dataset.src;
            if (!src) return;

            video.src = src;
            video.removeAttribute('data-src');
            video.dataset.loaded = 'true';
            video.load();

            if (isHeldStill(video)) {
                holdStill(video);
            } else if (video.hasAttribute('autoplay')) {
                video.play().catch(err => {
                    blockVideo(video);
                    console.warn(err);
                });
            }

            obs.unobserve(video);
        });
    }, { rootMargin: '200px 0px', threshold: 0.01 });

    videos.forEach(video => observer.observe(video));
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeLazyVideos);
} else {
    observeLazyVideos();
}
